import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  FiCheck,
  FiCopy,
  FiPlus,
  FiInfo,
  FiImage,
  FiTrash2,
  FiArchive,
  FiEdit,
  FiChevronLeft,
  FiChevronRight,
} from "react-icons/fi";
import {
  clearSelectedProduct,
  deleteProduct,
  getCartProducts,
  getCartProductsByPage,
  selectProduct,
  setProductsPageSize,
  updateProduct,
} from "../../actions/CheckoutsActions";
import { Link } from "react-router-dom";
import * as ROUTES from "../../../constants/routes";
import history from "../../../History";
import toast from "react-hot-toast";
import { Spinner, Tab, Tabs } from "react-bootstrap";
import MessageBlock from "../common/MessageBlock";
import { parseError } from "../../actions/ActionHelpers";
import { toMoneyFormat } from "../common/helpers";
import Popup from "../common/Popup";
import { BsThreeDotsVertical } from "react-icons/bs";
import Pagination from "../common/Pagination";

const CheckoutProductItem = (props) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, [1000]);
    }
  }, [copied]);

  const renderImage = (images) => {
    if (!!images.length) {
      const image = images.find((image) => !!image?.image);
      if (image) {
        return <img src={image.image} />;
      }
    }
    return <FiImage />;
  };

  const renderPrice = (variations) => {
    if (!!variations.length) {
      const variation = variations
        .sort((var1, var2) => {
          if (!var1?.price) return 1;
          if (!var2?.price) return -1;
          const varOnePrice = parseFloat(var1.price);
          const varTwoPrice = parseFloat(var2.price);
          if (varOnePrice < varTwoPrice) return -1;
          if (varTwoPrice < varOnePrice) return 1;
          return 0;
        })
        .find((variation) => !!variation?.price);
      if (variation) {
        return <p>{toMoneyFormat(variation.price, props.currency)}</p>;
      }
    }
    return <p>-</p>;
  };

  const { id, images, title, variations, sku, checkout_url, is_archived } =
    props.item;
  return (
    <tr
      key={id}
      onClick={() => props.select()}
      className={"checkout-product-list-item"}
    >
      <td>{renderImage(images)}</td>
      <td>
        <p>{title}</p>
      </td>
      <td>{renderPrice(variations)}</td>
      <td>
        {!is_archived && (
          <a
            onClick={(e) => {
              e.stopPropagation();
              navigator.clipboard.writeText(checkout_url).then(() => {
                setCopied(true);
                toast("Copied");
              });
            }}
          >
            {copied ? (
              <FiCheck className={"copied"} />
            ) : (
              <div
                className={
                  "w-100 d-flex flex-row align-items-center justify-content-center"
                }
              >
                <p className={"mr-3"}>Copy URL</p>
                <FiCopy />
              </div>
            )}
          </a>
        )}
      </td>
      <td>
        <button
          className={"button-secondary"}
          onClick={(e) => {
            e.stopPropagation();
            props.toggleMenu(e.target);
          }}
        >
          {/*<a>Edit</a>*/}
          <BsThreeDotsVertical />
        </button>
      </td>
    </tr>
  );
};

const CheckoutProductsList = (props) => {
  const [actionItem, setActionItem] = useState(null);
  const [actionElement, setActionElement] = useState(null);
  const [showAction, setShowAction] = useState(false);
  const [showArchiveConfirmation, setShowArchiveConfirmation] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [archived, setArchived] = useState(false);

  const filters = `&archived=${archived}`;

  const getProducts = useCallback(() => {
    if (props.selectedConfig?.shop)
      props.getCartProducts(
        props.selectedConfig.shop,
        null,
        props.pageSize,
        filters,
      );
  }, [filters]);

  useEffect(() => {
    getProducts();
  }, [archived]);

  const closeModal = (closeFn) => {
    closeFn?.();
    toggleActionMenu(actionItem, null);
  };

  const toggleActionMenu = (item, element) => {
    setActionItem((prevItem) => {
      if (prevItem && prevItem.id === item.id) {
        setActionElement(null);
        setShowAction(false);
        return null;
      }

      setActionElement(element);
      setShowAction(true);
      return item;
    });
  };

  const renderArchiveConfirmation = () => {
    if (showArchiveConfirmation) {
      return (
        <div className="modal">
          <div
            className="backdrop"
            onClick={() => closeModal(setShowArchiveConfirmation(false))}
          ></div>
          <div className="modal-content confirmation">
            <div className={"icon-container"}>
              <FiArchive />
            </div>
            <div>
              <p>
                {actionItem.is_archived
                  ? "Unarchiving will make this product available in your store again."
                  : "Archiving will make this product unavailable in your store. You can unarchive it anytime to make it available again."}
              </p>
              <p>{`Are you sure you want to ${actionItem.is_archived ? "unarchive" : "archive"} ${actionItem?.title || "this product"}?`}</p>
            </div>
            <div className="col-12 p-0 d-flex flex-column flex-lg-row justify-content-between">
              <button
                onClick={() => {
                  closeModal(
                    setShowArchiveConfirmation(!showArchiveConfirmation),
                  );
                }}
              >
                Cancel
              </button>
              <button
                onClick={() =>
                  props.updateProduct(
                    {
                      is_archived: !actionItem.is_archived,
                      title: actionItem.title,
                      description: actionItem.description,
                      price: actionItem.variations?.[0]?.price,
                      sku: actionItem.sku,
                    },
                    props.selectedConfig?.shop,
                    () => {
                      closeModal(setShowArchiveConfirmation(false));
                      getProducts();
                    },
                  )
                }
                className="delete-button"
              >
                {props.loading ? (
                  <div className="spinner-border m-auto" role="status"></div>
                ) : (
                  `${actionItem.is_archived ? "Unarchive" : "Archive"} Product`
                )}
              </button>
            </div>
          </div>
        </div>
      );
    }
  };

  const renderDeleteConfirmation = () => {
    if (showDeleteConfirmation) {
      return (
        <div className="modal">
          <div
            className="backdrop"
            onClick={() => closeModal(setShowDeleteConfirmation(false))}
          ></div>
          <div className="modal-content confirmation">
            <div className={"icon-container"}>
              <FiTrash2 />
            </div>
            <div>
              <p>
                You are about to delete{" "}
                <b>{actionItem?.title || "this product"}</b>
              </p>
              <p>Are you sure?</p>
            </div>
            <div className="col-12 p-0 d-flex flex-column flex-lg-row justify-content-between">
              <button
                onClick={() =>
                  closeModal(setShowDeleteConfirmation(!showDeleteConfirmation))
                }
              >
                Cancel
              </button>
              <button
                onClick={() =>
                  props.deleteProduct(
                    actionItem,
                    props.selectedConfig?.shop,
                    () => {
                      closeModal(setShowDeleteConfirmation(false));
                      getProducts();
                    },
                  )
                }
                className="delete-button"
              >
                {props.loading ? (
                  <div className="spinner-border m-auto" role="status"></div>
                ) : (
                  "Delete Product"
                )}
              </button>
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <div className={"checkout-product-list settings-card"}>
      {props.errors && (
        <MessageBlock
          icon={<FiInfo />}
          type={"error"}
          message={parseError(props.errors)}
        />
      )}
      <div className={"card-section head"}>
        <h3>Products</h3>
        {!archived ? (
          <Link className={"action"} to={ROUTES.CHECKOUTS_PRODUCTS_CREATE}>
            <FiPlus />
            Add Products
          </Link>
        ) : null}
      </div>
      <div className={"card-section last"}>
        <Tabs
          id="product-list-tabs"
          activeKey={archived ? "archived" : "unarchived"}
          onSelect={(k) => setArchived(k === "archived")}
          className="product-list-tabs mb-3"
        >
          <Tab eventKey={"unarchived"} title={"Active"} />
          <Tab eventKey={"archived"} title={"Archived"} />
        </Tabs>
        {props.loading ? (
          <Spinner animation={"border"} />
        ) : props.products?.length > 0 ? (
          <>
            <table>
              <thead>
                <tr>
                  <th></th>
                  <th>Product Name</th>
                  {/*<th>Status</th>*/}
                  <th>Price</th>
                  <th>Checkout URL</th>
                  <th>Action</th>
                </tr>
              </thead>

              {props.products.map((item) => {
                return (
                  <tbody key={item.id}>
                    <CheckoutProductItem
                      key={item.id}
                      item={item}
                      select={() =>
                        props.selectProduct(item, () =>
                          history.push(ROUTES.CHECKOUTS_PRODUCTS_CREATE),
                        )
                      }
                      currency={props.selectedConfig.currency}
                      toggleMenu={(element) => toggleActionMenu(item, element)}
                    />
                  </tbody>
                );
              })}
            </table>

            <Pagination
              current={props.current}
              count={props.count}
              pageSize={props.pageSize}
              getListByPage={(pageNo) =>
                props.getCartProductsByPage(
                  props.selectedConfig.shop,
                  pageNo,
                  null,
                  props.pageSize,
                  filters,
                )
              }
              setPageSize={(size) => {
                props.setProductsPageSize(size);
                props.getCartProducts(
                  props.selectedConfig.shop,
                  null,
                  size,
                  filters,
                );
              }}
            />
          </>
        ) : archived ? (
          <div className={"empty-product-list"}>
            <p>
              No archived products found. Once a product is archived it will be
              shown here.
            </p>
          </div>
        ) : (
          <div className={"empty-product-list"}>
            <p>
              Your Shop has been created! but no products are currently listed
            </p>
            <Link to={ROUTES.CHECKOUTS_PRODUCTS_CREATE}>
              List your first product!
            </Link>
          </div>
        )}
      </div>
      <Popup
        show={showAction && !showArchiveConfirmation && !showDeleteConfirmation}
        element={actionElement}
        top={(actionElement?.getBoundingClientRect().top || 0) + 30 + "px"}
        right={"135px"}
        onC
      >
        <Popup.Item
          className={
            "table-actions-item d-flex flex-row align-items-center justify-content-start"
          }
          onClick={() => {
            props.selectProduct(actionItem, () =>
              history.push(ROUTES.CHECKOUTS_PRODUCTS_CREATE),
            );
          }}
        >
          <FiEdit />
          <p>Edit</p>
        </Popup.Item>
        <Popup.Item
          className={
            "table-actions-item d-flex flex-row align-items-center justify-content-start"
          }
          onClick={() => {
            setShowArchiveConfirmation(true);
          }}
        >
          <FiArchive />
          <p>{`${actionItem?.is_archived ? "Unarchive" : "Archive"}`}</p>
        </Popup.Item>
        <Popup.Item
          className={
            "table-actions-item d-flex flex-row align-items-center justify-content-start"
          }
          onClick={() => {
            setShowDeleteConfirmation(true);
          }}
        >
          <FiTrash2 />
          <p>Delete</p>
        </Popup.Item>
      </Popup>
      {renderArchiveConfirmation()}
      {renderDeleteConfirmation()}
    </div>
  );
};

const mapStateToProps = ({ checkouts }) => ({
  products: checkouts.products,
  selectedConfig: checkouts.selectedConfig,
  selectedProduct: checkouts.selectedProduct,
  loading: checkouts.loadingProducts,
  errors: checkouts.productErrors,
  res: checkouts.productsResponse,
  count: checkouts.productsResponse?.count || null,
  current: checkouts.currentPage,
  pageSize: checkouts.pageSize,
});

export default connect(mapStateToProps, {
  getCartProducts,
  getCartProductsByPage,
  setProductsPageSize,
  selectProduct,
  clearSelectedProduct,
  updateProduct,
  deleteProduct,
})(CheckoutProductsList);
